import { render, staticRenderFns } from "./DriverGlobalHeader.vue?vue&type=template&id=5c2ce781&scoped=true"
import script from "./DriverGlobalHeader.vue?vue&type=script&lang=ts"
export * from "./DriverGlobalHeader.vue?vue&type=script&lang=ts"
import style0 from "./DriverGlobalHeader.vue?vue&type=style&index=0&id=5c2ce781&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c2ce781",
  null
  
)

export default component.exports